import React from "react";
import dayjs from "dayjs";
import { useDarkModeStore } from "../../../../store/useDarkModeStore";
import { useLanguageStore } from "../../../../store/useLanguageStore";
import { TicketInterface } from "../../../../models/TicketModule/Ticket";
import { TimelineStoppageType } from "../../../../enums/timelineStoppageType";

const { PAUSED, STOPPED, SYSTEMSTOPPED } = TimelineStoppageType;
interface TimelineProps {
  ticketById: TicketInterface;
}

export const Timeline: React.FC<TimelineProps> = ({ ticketById }) => {

  const { darkMode } = useDarkModeStore();
  const { language } = useLanguageStore();

  const formatMinutesToTime = (totalMinutes: number) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);

    return dayjs().hour(hours).minute(minutes).format("HH:mm");
  };

  const handleStoppageType = (type: TimelineStoppageType) => {
    if (type === PAUSED) return language['Paused'] ?? 'Paused';
    else if (type === STOPPED) return language['Stopped'] ?? 'Stopped';
    else if (type === SYSTEMSTOPPED) return 'System Stopped'
  }

  return (
    <div>
      <div
        className="mt-4 mb-3 d-flex align-items-center"
        style={{
          color: darkMode ? "white" : "rgba(0, 0, 0, 0.6)",
          borderBottom: "2px solid #D8DDE2",
          fontSize: "20px",
        }}
      >
        {language["TicketTimeline"]}
      </div>

      <div className="table-container" style={{ overflowX: "auto" }}>
        <table className="table table-hover bg-white">
          <thead>
            <tr>
              <th style={{ width: '15%' }}>{language["StoppageType"]}</th>
              <th style={{ width: '15%' }}>{language["StartTime"]}</th>
              <th style={{ width: '15%' }}>{language["EndTime"]}</th>
              <th style={{ width: '15%' }}>{language["Duration"]}</th>
              <th style={{ width: '40%' }}>{language["Comment"]}</th>
            </tr>
          </thead>
          <tbody>
            {ticketById.ticketTimelines &&
              ticketById.ticketTimelines.map((i) => (
                <tr key={i.id}>
                  <td>
                    {handleStoppageType(i.timelineStoppageType)}
                  </td>
                  <td>
                    {i.startTime
                      ? dayjs(i.startTime).format("DD-MM-YYYY HH:mm")
                      : "--/--/----"}
                  </td>
                  <td>
                    {i.endTime
                      ? dayjs(i.endTime).format("DD-MM-YYYY HH:mm")
                      : "--/--/----"}
                  </td>

                  <td>{formatMinutesToTime(i.duration)}</td>
                  <td title={i.comment ?? ''} className="text-truncate" style={{ maxWidth: 400 }}>
                    {i.comment ?? ''}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default Timeline;
